import { getFontSize } from '../../../../constants/fontSizes';

export const helpSectionStyles = {
  card: {
    padding: '40px',
    backgroundColor: 'secondary.main',
    borderRadius: '14px',
    boxShadow: 'none',
    height: 'fit-content',
  },
  title: {
    fontFamily: 'Aurora',
    fontWeight: 700,
    fontSize: {xs: "35px", lg: "30px"},
    lineHeight: '38px',
    letterSpacing: '-1%',
    color: '#1F1F1F',
    marginBottom: '24px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: {xs: "10px", lg: '20px'},
  },
  introText: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(20),
    lineHeight: {xs: "20px", lg: '28px'},
    letterSpacing: '-1%',
    color: '#818181',
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  listItem: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(20),
    lineHeight: {xs: "15px", lg: '28px'},
    letterSpacing: '-1%',
    color: '#818181',
  },
  listNumber: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: getFontSize(20),
    lineHeight: {xs: "15px", lg: '28px'},
    letterSpacing: '-1%',
    color: '#818181',
  },
  closingText: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(20),
    lineHeight: {xs: "15px", lg: '28px'},
    letterSpacing: '-1%',
    color: '#818181',
    marginTop: '8px',
  },
};

